export default {
  'reports.title': 'Gestionar Reportes',
  'reports.reportGroups': 'Grupo de Reportes',
  'reports.permissions.description': 'Agregue o retire quién puede acceder al reporte {name}.',
  'reports.form.reportGroup': 'Grupo de Reportes',
  'reports.form.provider': 'Proveedor',
  'reports.form.reportId': 'Id Reporte PowerBI',
  'reports.form.datasetId': 'Id Dataset PowerBI',
  'reports.form.workspaceId': 'Id Workspace Power BI',
  'reports.form.defaultReportSection': 'Sección del Reporte Predeterminada',
  'reports.form.isMultipage': '¿Múltiples Páginas?',
  'reports.form.isReportDataFilterByUserEnabled': '¿Filtro de Datos por Usuario?',
  'reports.form.isReportDataFilterByPositionEnabled': '¿Filtro de Datos por Puesto?',
  'reports.form.reportDataFilterUserTableName': 'Nombre de tabla para filtro por usuario',
  'reports.form.reportDataFilterUserFieldName': 'Nombre de campo para filtro por usuario',
  'reports.form.reportDataFilterUserFieldNameInternal':
    'Nombre interno de campo para filtro por usuario',
  'reports.form.reportDataFilterPositionTableName': 'Nombre de tabla para filtro por puesto',
  'reports.form.reportDataFilterPositionFieldName': 'Nombre de campo para filtro por puesto',
  'reports.form.reportDataFilterPositionFieldNameInternal':
    'Nombre interno de campo para filtro por puesto',
  'reports.form.isReportDataFilterByAreaEnabled': '¿Filtro de Datos por Área?',
  'reports.form.reportDataFilterAreaTableName': 'Nombre de tabla para filtro por área',
  'reports.form.reportDataFilterAreaFieldName': 'Nombre de campo para filtro por área',
  'reports.form.reportDataFilterAreaFieldNameInternal':
    'Nombre interno de campo para filtro por área',
  'reports.form.isReportDataFilterByDynamicEntityEnabled': '¿Filtro de Datos por Entidad Dinámica?',
  'reports.form.reportDataFilterDynamicEntityTableName':
    'Nombre de tabla para filtro por entidad dinámica',
  'reports.form.reportDataFilterDynamicEntityFieldName':
    'Nombre de campo para filtro por entidad dinámica',
  'reports.form.reportDataFilterDynamicEntityId': 'Entidad Dinámica',
  'reports.form.reportDataFilterDynamicEntityFieldUserFieldId': 'Entidad Dinámica / Campo Usuario',
  'reports.form.reportDataFilterDynamicEntityFieldDataFieldId': 'Entidad Dinámica / Campo Filtro',
  'reports.form.isReportDataFilterByUserGroupsEnabled': '¿Filtro de Datos por Grupo de Usuarios?',
  'reports.form.reportDataFilterUserGroupTableName':
    'Nombre de tabla para filtro por grupo de usuarios',
  'reports.form.reportDataFilterUserGroupFieldName':
    'Nombre de campo para filtro por grupo de usuarios',
  'reports.form.reportDataFilterUserGroupFieldNameInternal':
    'Nombre interno de campo para filtro por grupo de usuarios',
  'reports.type.administration': 'Administración',
  'reports.type.process': 'Proceso',
  'reports.type.request': 'Solicitud',
  'reports.type.generic': 'Genérico',
  'reports.platform.web': 'Web',
  'reports.platform.mobile': 'Móvil',
  'reports.platform.webMobile': 'Web y Móvil',
  'reports.provider.native': 'Nativo',
  'reports.provider.powerbi': 'Power BI',
  'reports.logicalOperator.or': 'OR',
  'reports.logicalOperator.and': 'AND',
  'reports.form.provider': 'Motor',
  'reports.provider.native': 'Nativo',
  'reports.provider.powerbi': 'Power BI',
  'reports.form.owner': 'Propietario',
  'reports.form.processId': 'Proceso',
  'reports.form.powerBIServerConfigurationId': 'Servidor Power BI',
  'reports.form.accessControl.users': 'Usuarios',
  'reports.form.accessControl.userGroups': 'Grupos de usuario',
  'reports.form.accessControl.positions': 'Posiciones',
  'reports.form.accessControl.areas': 'Áreas',
  'reports.form.accessControl.filtersLogicalOperator': 'Operador del control de acceso',
  'reports.form.accessControl.userGroupsFiltersLogicalOperator':
    'Operador entre grupos, posiciones y áreas',
  'reports.form.accessControl.operator.and': 'AND (Todas las condiciones)',
  'reports.form.accessControl.operator.or': 'OR (Alguna condición)',
  'reports.form.isReportDataFilterByUserCompanyEnabled': '¿Filtro de Datos por Compañía?',
  'reports.form.reportDataFilterUserCompanyTableName':
    'Nombre de tabla para filtro por compañía',
  'reports.form.reportDataFilterUserCompanyFieldName':
    'Nombre de campo para filtro por compañía',
  'reports.form.reportDataFilterUserCompanyFieldNameInternal':
    'Nombre interno de campo para filtro por compañía',
  'reports.form.isReportDataFilterByUserEnvironmentEnabled': '¿Filtro de Datos por Ambiente?',
  'reports.form.reportDataFilterUserEnvironmentTableName':
    'Nombre de tabla para filtro por ambiente',
  'reports.form.reportDataFilterUserEnvironmentFieldName':
    'Nombre de campo para filtro por ambiente',
  'reports.form.reportDataFilterUserEnvironmentFieldNameInternal':
    'Nombre interno de campo para filtro por ambiente',
  'reports.builder.title': 'Report Builder',
  'reports.builder.error.notFound': 'El reporte no existe o no se encontró',
  'reports.builder.session.error':
    'No se pudo abrir una sesión de edición. Puedes editar el reporte desde el formulario y reintentar más tarde.',
  'reports.builder.create.error': 'No se pudo crear el reporte',
  'reports.builder.new.title': 'Nuevo reporte',
  'reports.builder.new.continue': 'Continuar',
  'reports.builder.publish.success': 'Reporte publicado',
  'reports.builder.publish.error': 'No se pudo publicar el reporte',
  'reports.builder.setCurrent': 'Establecer actual',
  'reports.builder.setCurrent.success': 'Versión establecida como actual exitosamente',
  'reports.builder.setCurrent.error': 'Error al establecer la versión como actual',
  'reports.builder.publish.codeRequired':
    'Publicar requiere code.js con contenido o una URL de documento.',
  'reports.builder.version.error': 'No se pudo cambiar de versión',
  'reports.builder.unsaved.confirm': 'Hay cambios sin guardar. ¿Salir de todos modos?',
  'reports.builder.unsaved.indicator': 'Cambios sin guardar',
  'reports.builder.open': 'Abrir',
  'reports.builder.notPublished': 'Este reporte aún no está publicado',
  'reports.builder.notPublished.description': 'Publica una versión para que los usuarios puedan verlo.',
  'reports.builder.section.identity': 'Información básica',
  'reports.builder.section.accessControl': 'Control de acceso',
  'reports.builder.accessControl.legend': 'Quién puede abrir el reporte.',
  'reports.builder.section.datasets': 'Datasets',
  'reports.builder.section.queries': 'Consultas',
  'reports.builder.section.filters': 'Filtros',
  'reports.builder.section.parameters': 'Parámetros',
  'reports.builder.section.code': 'Código',
  'reports.builder.code': 'Código',
  'reports.builder.code.empty': 'Todavía no hay code.js ni code.css en este borrador.',
  'reports.builder.code.emptyFile': 'Este archivo no tiene contenido.',
  'reports.builder.section.settings': 'Ajustes',
  'reports.builder.elements.code.html': 'HTML',
  'reports.builder.elements.code.js': 'JavaScript',
  'reports.builder.elements.code.css': 'CSS',
  'reports.builder.elements.code.save': 'Guardar código',
  'reports.builder.elements.code.attachmentHint':
    'Este archivo está en un adjunto. Al guardar se reemplaza por el texto de este panel.',
  'reports.builder.elements.settings.json': 'Ajustes (JSON)',
  'reports.builder.elements.settings.save': 'Guardar ajustes',
  'reports.builder.elements.settings.invalid': 'El JSON de ajustes no es válido.',
  'reports.builder.elements.settings.legend':
    'Objeto reservado de ConfigNativeReport.settings. No inventes campos: título, carpeta y propietario van en Información básica. El control de acceso es otro drawer.',
  'reports.builder.identity.legend':
    'Identidad del reporte (padre). Se guarda con PUT /report, no es un elemento del builder ni requiere Publish.',
  'reports.builder.identity.save': 'Guardar',
  'reports.builder.elements.save.success': 'Cambios enviados a la versión.',
  'reports.builder.elements.save.error': 'No se pudo guardar el elemento.',
  'reports.builder.elements.datasetKey': 'Clave de dataset',
  'reports.builder.elements.datasetKey.legend':
    'Usa el catálogo. Las claves de proceso llevan processIds; users, positions, areas, user-groups, user-group-users, processes, process-groups y dynamic-entity no.',
  'reports.builder.elements.catalogRef': 'Dataset',
  'reports.builder.elements.catalogRef.legend':
    'Elige un dataset del catálogo. Si es formulario o entidad, completa el origen y se arma la clave.',
  'reports.builder.dataset.add': 'Agregar dataset',
  'reports.builder.dataset.addHint': 'Elige el origen y, si hace falta, el proceso o la entidad.',
  'reports.builder.dataset.configured': 'Agregados',
  'reports.builder.dataset.empty': 'Todavía no hay datasets en este reporte.',
  'reports.builder.dataset.close': 'Cerrar',
  'reports.builder.dataset.cancelEdit': 'Cancelar',
  'reports.builder.dataset.previewKey': 'Clave',
  'reports.builder.dataset.changeHint': 'Si guardas, la clave pasa de {from} a {to}.',
  'reports.builder.dataset.duplicate': 'Ese dataset ya está en el reporte.',
  'reports.builder.dataset.removeConfirm': '¿Quitar este dataset del reporte?',
  'reports.builder.dataset.inUse':
    'Quita primero las consultas que usan este dataset ({query}).',
  'reports.builder.dataset.fields': 'Campos',
  'reports.builder.dataset.table.field': 'Campo',
  'reports.builder.dataset.table.type': 'Tipo',
  'reports.builder.dataset.table.relation': 'Relación',
  'reports.builder.dataset.table.processCount':
    '{count, plural, one {# proceso} other {# procesos}}',
  'reports.builder.dataset.table.fieldCount': '{count, plural, one {# campo} other {# campos}}',
  'reports.builder.dataset.table.noFields': 'Sin campos resueltos todavía',
  'reports.builder.dataset.fieldType.guid': 'GUID',
  'reports.builder.dataset.fieldType.text': 'Texto',
  'reports.builder.dataset.fieldType.number': 'Número',
  'reports.builder.dataset.fieldType.boolean': 'Booleano',
  'reports.builder.dataset.fieldType.date': 'Fecha',
  'reports.builder.dataset.fieldType.datetime': 'Fecha y hora',
  'reports.builder.dataset.fieldType.user': 'Usuario',
  'reports.builder.dataset.fieldType.reference': 'Referencia',
  'reports.builder.dataset.fieldType.position': 'Puesto',
  'reports.builder.dataset.fieldType.area': 'Área',
  'reports.builder.dataset.fieldType.user-group': 'Grupo de usuarios',
  'reports.builder.catalog.kind.static': 'Estático',
  'reports.builder.catalog.kind.processFormData': 'Datos de formulario',
  'reports.builder.catalog.kind.dynamicEntity': 'Entidad dinámica',
  'reports.builder.elements.catalog.loading': 'Cargando catálogo de datasets…',
  'reports.builder.elements.catalog.incompleteKey':
    'Completa el proceso y el formulario, o la entidad, para armar la clave.',
  'reports.builder.elements.templateProcessId': 'Proceso del formulario',
  'reports.builder.elements.templateFormId': 'Formulario',
  'reports.builder.elements.templateEntityId': 'Entidad dinámica',
  'reports.builder.elements.processIds': 'Procesos del dataset',
  'reports.builder.elements.processIds.legend':
    'Obligatorio en datasets de proceso (process-instances y similares). process-form-data, users, positions, areas, user-groups, user-group-users, processes, process-groups y dynamic-entity no lo envían.',
  'reports.builder.elements.processIds.required':
    'Este dataset requiere al menos un proceso.',
  'reports.builder.elements.filterKey': 'Identificador',
  'reports.builder.elements.filterKey.legend':
    'Clave técnica del filtro. Es metadata del builder; no se ejecuta en runtime.',
  'reports.builder.elements.filterLabel': 'Nombre visible',
  'reports.builder.elements.filterLabel.legend':
    'Texto de respaldo si el catálogo no trae label. No alimenta el runtime.',
  'reports.builder.filter.dataset': 'Dataset',
  'reports.builder.elements.filterDataset.legend':
    'Elige un dataset ya agregado al reporte. Los campos salen del catálogo.',
  'reports.builder.filter.pickDataset': 'Elegir dataset',
  'reports.builder.filter.pickDataset.empty': 'Usa un dataset ya agregado',
  'reports.builder.filter.pickDataset.search': 'Buscar datasets del reporte…',
  'reports.builder.filter.pickDataset.none': 'No hay datasets que coincidan',
  'reports.builder.elements.fieldKey': 'Campo',
  'reports.builder.elements.fieldKey.legend':
    'El tipo y el selector salen del catálogo. No se guarda source en el filtro.',
  'reports.builder.elements.fieldKey.relation':
    'Selector: {dataset}.{displayField}',
  'reports.builder.elements.behavior': 'Comportamiento',
  'reports.builder.elements.operator': 'Operador',
  'reports.builder.elements.filterValue': 'Valor',
  'reports.builder.elements.filterValue.legend':
    'Usa ; para listas (in / not-in) o para el rango (between). Déjalo vacío en is-null / is-not-null.',
  'reports.builder.elements.filterContextValue': 'Valor de contexto',
  'reports.builder.elements.filterContextValue.legend':
    'En v1 el único valor de contexto es $currentUser.',
  'reports.builder.elements.filterDefaultValue': 'Valor inicial',
  'reports.builder.elements.filterDefaultValue.legend':
    'Solo aplica a filtros available. Misma forma que el valor.',
  'reports.builder.filter.add': 'Agregar filtro',
  'reports.builder.filter.addHint': 'Elige el dataset, el campo y cómo se aplica.',
  'reports.builder.filter.configured': 'Agregados',
  'reports.builder.filter.empty': 'Todavía no hay filtros en este reporte.',
  'reports.builder.filter.noDatasets': 'Agrega un dataset antes de crear filtros.',
  'reports.builder.filter.removeConfirm': '¿Quitar este filtro del reporte?',
  'reports.builder.filter.duplicate': 'Esa clave de filtro ya está en el reporte.',
  'reports.builder.filter.valueRequired': 'Este operador requiere un valor.',
  'reports.builder.filter.contextValueRequired':
    'Contexto requiere el valor $currentUser.',
  'reports.builder.filter.metadata':
    'Estos filtros son metadata del builder. No se ejecutan. La restricción de datos va en la consulta (queries[].filter).',
  'reports.builder.filter.details': 'Detalle',
  'reports.builder.filter.fieldManual':
    'El catálogo no trajo campos. Puedes escribir la clave a mano.',
  'reports.builder.filter.behavior.legend':
    'Metadata de compatibilidad. Fijo, disponible y contexto no se aplican al runtime de queryKey. Contexto solo acepta $currentUser.',
  'reports.builder.filter.behavior.fixed': 'Fijo',
  'reports.builder.filter.behavior.available': 'Disponible',
  'reports.builder.filter.behavior.context': 'Contexto',
  'reports.builder.filter.operator.eq': 'Igual',
  'reports.builder.filter.operator.neq': 'Distinto',
  'reports.builder.filter.operator.in': 'En lista',
  'reports.builder.filter.operator.notIn': 'Fuera de lista',
  'reports.builder.filter.operator.gt': 'Mayor que',
  'reports.builder.filter.operator.gte': 'Mayor o igual',
  'reports.builder.filter.operator.lt': 'Menor que',
  'reports.builder.filter.operator.lte': 'Menor o igual',
  'reports.builder.filter.operator.contains': 'Contiene',
  'reports.builder.filter.operator.startsWith': 'Empieza con',
  'reports.builder.filter.operator.endsWith': 'Termina con',
  'reports.builder.filter.operator.between': 'Entre',
  'reports.builder.filter.operator.isNull': 'Es nulo',
  'reports.builder.filter.operator.isNotNull': 'No es nulo',
  'reports.builder.elements.parameterKey': 'Clave de parámetro',
  'reports.builder.elements.parameterKey.legend':
    'Solo { key }. Letra o _ al inicio; el runtime de consume lo usa como input.',
  'reports.builder.elements.parameter.legend':
    'Parámetros de consume del reporte, sin tipo. No ejecutan Synapse. Los parámetros vivos (tipo + required) van en cada consulta.',
  'reports.builder.parameter.add': 'Agregar parámetro',
  'reports.builder.parameter.addHint': 'Elige un nombre. Quien vea el reporte podrá indicar el valor.',
  'reports.builder.parameter.configured': 'Agregados',
  'reports.builder.parameter.empty': 'Todavía no hay parámetros en este reporte.',
  'reports.builder.parameter.removeConfirm': '¿Quitar este parámetro del reporte?',
  'reports.builder.parameter.duplicate': 'Esa clave de parámetro ya está en el reporte.',
  'reports.builder.parameter.keyInvalid':
    'La clave debe empezar con letra o _ y solo usar letras, números y _.',
  'reports.builder.query.add': 'Agregar consulta',
  'reports.builder.query.addHint': 'Elige el dataset, el tipo y cómo se agrupa.',
  'reports.builder.query.configured': 'Agregadas',
  'reports.builder.query.empty': 'Todavía no hay consultas en este reporte.',
  'reports.builder.query.removeConfirm': '¿Quitar esta consulta del reporte?',
  'reports.builder.query.pickDataset': 'Elegir dataset',
  'reports.builder.query.pickDataset.empty': 'Usa un dataset ya agregado',
  'reports.builder.query.pickDataset.legend':
    'La consulta solo puede leer un dataset ya agregado. No se puede ampliar el alcance.',
  'reports.builder.query.pickDataset.search': 'Buscar datasets del reporte…',
  'reports.builder.query.pickDataset.none': 'No hay datasets que coincidan',
  'reports.builder.query.key': 'Clave de consulta',
  'reports.builder.query.key.legend':
    'Única. El runtime la usa como queryKey: reporting.query(clave, parámetros).',
  'reports.builder.query.type': 'Tipo',
  'reports.builder.query.type.rows': 'Filas',
  'reports.builder.query.type.aggregate': 'Agregado',
  'reports.builder.query.metrics': 'Métricas',
  'reports.builder.query.metricKey': 'Clave de métrica',
  'reports.builder.query.metricOp': 'Operación',
  'reports.builder.query.addMetric': 'Agregar métrica',
  'reports.builder.query.metric.count': 'Conteo',
  'reports.builder.query.metric.countDistinct': 'Conteo distinto',
  'reports.builder.query.metric.sum': 'Suma',
  'reports.builder.query.metric.average': 'Promedio',
  'reports.builder.query.metric.min': 'Mínimo',
  'reports.builder.query.metric.max': 'Máximo',
  'reports.builder.query.dimensions': 'Dimensiones',
  'reports.builder.query.dimensionKey': 'Clave de dimensión',
  'reports.builder.query.addDimension': 'Agregar dimensión',
  'reports.builder.query.bucket': 'Agrupación',
  'reports.builder.query.bucket.day': 'Día',
  'reports.builder.query.bucket.week': 'Semana ISO',
  'reports.builder.query.bucket.month': 'Mes',
  'reports.builder.query.bucket.quarter': 'Trimestre',
  'reports.builder.query.bucket.year': 'Año',
  'reports.builder.query.select': 'Campos',
  'reports.builder.query.select.legend':
    'Solo claves semánticas del catálogo. Sin SQL ni columnas físicas.',
  'reports.builder.query.filter': 'Filtro de la consulta',
  'reports.builder.query.filter.legend':
    'Este filter sí se ejecuta. Distinto de los filtros del builder. Usa un valor o un parameterKey declarado.',
  'reports.builder.query.filterValue': 'Valor',
  'reports.builder.query.filterParameter': 'Parámetro',
  'reports.builder.query.parameters': 'Parámetros ejecutables',
  'reports.builder.query.parameterKey': 'Clave',
  'reports.builder.query.parameterType': 'Tipo',
  'reports.builder.query.parameterRequired': 'Obligatorio',
  'reports.builder.query.optional': 'Opcional',
  'reports.builder.query.required': 'Obligatorio',
  'reports.builder.query.addParameter': 'Agregar parámetro',
  'reports.builder.query.orderField': 'Ordenar por',
  'reports.builder.query.orderDirection': 'Dirección',
  'reports.builder.query.order.asc': 'Ascendente',
  'reports.builder.query.order.desc': 'Descendente',
  'reports.builder.query.limit': 'Límite',
  'reports.builder.query.limit.legend':
    'Máximo 5000. Filas por defecto 1000; agregado por defecto 5000.',
  'reports.builder.query.keyInvalid':
    'La clave debe empezar con letra o _ y solo usar letras, números o _.',
  'reports.builder.query.datasetMissing': 'La consulta debe usar un dataset ya agregado.',
  'reports.builder.query.duplicate': 'Esa clave de consulta ya está en el reporte.',
  'reports.builder.query.selectRequired': 'Una consulta de filas requiere al menos un campo.',
  'reports.builder.query.unknownField': 'Usa solo campos semánticos del catálogo.',
  'reports.builder.query.orderFieldInvalid':
    'El orden debe ser un campo seleccionado o una clave de dimensión/métrica.',
  'reports.builder.query.metricsRequired': 'Un agregado requiere al menos una métrica.',
  'reports.builder.query.outputKeyDuplicate': 'Las claves de dimensión y métrica deben ser únicas.',
  'reports.builder.query.metricFieldRequired': 'Esta operación requiere un campo.',
  'reports.builder.query.metricTypeInvalid': 'Esa operación no aplica al tipo del campo.',
  'reports.builder.query.bucketInvalid': 'La agrupación solo aplica a date o datetime.',
  'reports.builder.query.limitInvalid': 'El límite debe estar entre 1 y 5000.',
  'reports.builder.query.parameterInvalid':
    'El parámetro necesita una clave válida y un tipo permitido (sin user ni reference).',
  'reports.builder.query.parameterDuplicate': 'Esa clave de parámetro ya está en la consulta.',
  'reports.builder.query.filterParameterMissing':
    'El parameterKey del filtro debe existir en los parámetros de la consulta.',
  'reports.builder.elements.add': 'Agregar',
  'reports.builder.elements.save': 'Guardar',
  'reports.builder.elements.edit': 'Editar',
  'reports.builder.elements.remove': 'Quitar',
  'reports.builder.consume.filters': 'Filtros',
  'reports.builder.chat': 'Asistente',
  'reports.builder.chat.title': 'Asistente IA',
  'reports.builder.sidebar.overview': 'Vista general',
  'reports.builder.preview.empty': 'Tu reporte comienza aquí',
  'reports.builder.preview.empty.description':
    'Descríbelo en el chat para construirlo paso a paso',
  'reports.builder.preview.empty.hint': 'Escribe en el chat para comenzar',
  'reports.form.powerBiConfig.saveError':
    'El reporte se guardó, pero no se pudo guardar la configuración de Power BI. Vuelve a editarlo para reintentar.',
};
